export default [
    {
        path: "/orders",
        name: "orders",
        component: () => import('@/views/modules/orders/list'),
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Orders List",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Orders" }
            ]
        }
    },

    {
        path: "/orders/create",
        name: "orders-create",
        component: () => import("@/views/modules/orders/create"),
        meta: {
            sidebarToggle: false,
            requiresAuth: true,
            layout: "app",
            title: "Order Create",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Create" }
            ]
        }
    },
    {
        path: "/orders/rep-orders",
        name: "orders-rep-orders",
        component: () => import("@/views/modules/orders/rep-orders"),
        meta: {
            sidebarToggle:false,
            requiresAuth: true,
            layout: "app",
            title: "My Orders",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "My Orders" }
            ]
        }
    },
    {
        path: "/orders/process",
        name: "orders-process",
        component: () => import("@/views/modules/orders/process"),
        meta: {
            sidebarToggle:false,
            requiresAuth: true,
            layout: "app",
            title: "Orders Process",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Orders Process" }
            ]
        }
    },
   
];
